import { whatIsContent } from "./whatIs";
import { containerContent } from "./container";
import { benefitsContent } from "./benefits";

export const whatIsViewContent = {
  whatIsContent,
  containerContent,
  benefitsContent,
};
